// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"98":"bcf433683887844d","473":"70deb59cbee34b13","888":"f282abc684c3d307","899":"83e127447e0de684"}[chunkId] + ".css";
};